module.exports = new __parcel__URL__("squirrel.e3a31ee3.svg").toString();